module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ds-calendar-event-popover-card",
    class: _vm.classes
  }, [_c('v-toolbar', {
    style: (_vm.styleHeader),
    attrs: {
      "extended": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_vm._v("\n     " + _vm._s(_vm.details.title) + "\n     "), (_vm.details.icon) ? _c('v-icon', {
    style: (_vm.styleButton)
  }, [_vm._v("\n       " + _vm._s(_vm.details.icon) + "\n     ")]) : _vm._e()], 1), _vm._v(" "), (_vm.allowEdit) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "absolute": "",
      "bottom": "",
      "left": "",
      "fab": "",
      "icon": ""
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _vm._t("eventPopoverToolbarLeft", null, null, _vm.slotData), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("eventPopoverToolbarRight", null, null, _vm.slotData), _vm._v(" "), _vm._t("eventPopoverToolbarActions", [(!_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('ds-schedule-actions', _vm._g(_vm._b({
    attrs: {
      "slot": "activator",
      "schedule": _vm.calendarEvent.schedule,
      "calendar-event": _vm.calendarEvent,
      "calendar": _vm.calendar
    },
    slot: "activator"
  }, 'ds-schedule-actions', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners), [_c('v-btn', {
    style: (_vm.styleButton),
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.options))])], 1) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventPopoverToolbarClose", [_c('v-btn', {
    style: (_vm.styleButton),
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], null, _vm.slotData)], 2), _vm._v(" "), _c('v-card-text', [_vm._t("eventPopoverBodyTop", null, null, _vm.slotData), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverOccurs", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.occurs))])], null, _vm.slotData)], 2)], 1), _vm._v(" "), (_vm.details.location) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverLocation", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.location)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.description) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverDescription", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.description)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.notify) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("notifications")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverNotifications", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.notify)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.calendar) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverCalendar", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.calendar)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.hasBusy) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverBusy", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.busyness))])], null, _vm.slotData)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _vm._t("eventPopoverBodyBottom", null, null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventPopoverActions", null, null, _vm.slotData)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7461b951","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarEventPopover.vue
// module id = 418
// module chunks = 1